<template>
    <div>
        <rkm-area
            v-if="form && paciente.nome"
            title="Identificação"
            type="fieldset"
            no-margin-top
        >
            <rkm-row>
                <rkm-col class="flex-grow-1">
                    <rkm-row>
                        <rkm-col>
                            <h4>
                                {{ paciente.nome }}

                                <template v-if="paciente.nomeSocial">
                                    <template v-if="paciente.nomeSocial">
                                        <strong>({{ paciente.nomeSocial }})</strong>
                                    </template>

                                    <template v-else>
                                        ({{ paciente.nomeSocial }})
                                    </template>
                                </template>
                            </h4>
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="3">
                            <p>
                                <strong>CNS: </strong>
                                <template v-if="paciente.cns">
                                    {{ paciente.cns }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>

                            <p>
                                <strong>Situação familiar/conjugal: </strong>
                                <template v-if="paciente.situacaoFamiliar">
                                    {{ paciente.situacaoFamiliar }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>

                            <p>
                                <strong>Unidade de referência: </strong>
                                <template v-if="paciente.unidadeReferencia">
                                    {{ paciente.unidadeReferencia }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>
                        </rkm-col>

                        <rkm-col cols="3">
                            <p>
                                <strong>Tipo: </strong>
                                <template v-if="paciente.classificacaoId">
                                    {{ paciente.classificacaoNome }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>

                            <p>
                                <strong>RG: </strong>
                                <template v-if="paciente.rg">
                                    {{ paciente.rg }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>

                            <p>
                                <strong>Prontuário: </strong>
                                <template v-if="paciente.prontuario">
                                    {{ paciente.prontuario }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>
                        </rkm-col>

                        <rkm-col>
                            <p>
                                <strong>Data de nascimento: </strong>
                                <template v-if="paciente.dataNascimento">
                                    {{ paciente.dataNascimento }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>

                            <p>
                                <strong>CPF: </strong>
                                <template v-if="paciente.cpf">
                                    {{ paciente.cpf }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>

                            <p>
                                <strong>Telefone: </strong>
                                <template v-if="paciente.telefone">
                                    {{ paciente.telefone }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>
                        </rkm-col>

                        <rkm-col>
                            <p>
                                <strong>Sexo:</strong>
                                <template>
                                    {{ paciente.sexo }}
                                </template>
                            </p>

                            <p>
                                <strong>Convênio: </strong>
                                <template v-if="paciente.convenioMedicoNome">
                                    {{ paciente.convenioMedicoNome }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>
                        </rkm-col>
                    </rkm-row>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            v-if="form && endereco.tipo"
            title="Endereço"
            type="fieldset"
            no-margin-top
        >
            <rkm-row>
                <rkm-col class="flex-grow-1">
                    <rkm-row>
                        <rkm-col cols="3">
                            <p>
                                <strong>Logradouro: </strong>
                                <template v-if="endereco.logradouro">
                                    {{ endereco.logradouro.tipoNome }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>

                            <p>
                                <strong>CEP: </strong>
                                <template v-if="endereco.cep">
                                    {{ endereco.cep }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>
                        </rkm-col>

                        <rkm-col cols="3">
                            <p>
                                <strong>Número: </strong>
                                <template>
                                    {{ endereco.numero }}
                                </template>
                            </p>

                            <p>
                                <strong>Município: </strong>
                                <template v-if="endereco.municipio">
                                    {{ endereco.municipio }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>
                        </rkm-col>

                        <rkm-col>
                            <p>
                                <strong>Complemento: </strong>
                                <template>
                                    {{ endereco.complemento }}
                                </template>
                            </p>

                            <p>
                                <strong>UF: </strong>
                                <template v-if="endereco.uf">
                                    {{ endereco.uf }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>
                        </rkm-col>

                        <rkm-col>
                            <p>
                                <strong>Bairro:</strong>
                                <template>
                                    {{ endereco.bairro }}
                                </template>
                            </p>

                            <p>
                                <strong>Código IBGE: </strong>
                                <template v-if="endereco.ibge">
                                    {{ endereco.ibge }}
                                </template>
                                <template v-else>
                                    <i>Não informado</i>
                                </template>
                            </p>
                        </rkm-col>
                    </rkm-row>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            :title="model.exameNome"
            no-margin-top
            class="pb-0 mb-0"
        >
            <rkm-tabs>
                <rkm-tab title="EXAMES AGENDADOS">
                    <rkm-table
                        v-if="agendados"
                        :items="agendados || items"
                        :fields="fields"
                        sort-by="data"
                    >
                        <template v-slot:cell(actions)="{ item }">
                            <rkm-button
                                small
                                title="Visualizar"
                                color="primary"
                                @click="$refs.Modal.open(item)"
                            >
                                <rkm-icon icon="search" />
                            </rkm-button>
                        </template>
                    </rkm-table>
                </rkm-tab>

                <rkm-tab title="EXAMES REALIZADOS">
                    <rkm-table
                        v-if="realizados"
                        :items="realizados || items"
                        :fields="fields"
                        sort-by="data"
                    >
                        <template v-slot:cell(actions)="{ item }">
                            <rkm-button
                                small
                                title="Visualizar"
                                color="primary"
                                @click="$refs.Modal.open(item)"
                            >
                                <rkm-icon icon="search" />
                            </rkm-button>
                        </template>
                    </rkm-table>
                </rkm-tab>
            </rkm-tabs>
        </rkm-area>

        <Modal
            ref="Modal"
        />
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, error, object, formats, data, stringCase } from '@/mixins'

// Filters.
import format from '@/filters/formats'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

// Components.
import Modal from '@/components/exame-imagem/exame-agendado-realizado/Modal'

export default {
    components: { Modal },
    computed: {
        fields() {
            const fields = [

                { key: "data", label: "Data do agendamento", class: 'col-min', sortable: true },
                { key: "agendamentoNumero", label: "Agendamento", class: 'col-min', sortable: true },
                { key: "grupoExameNome", label: "Grupo de exame", class: 'col-min', sortable: true },
                { key: "unidadeNome", label: "Unidade executante", class: 'col-max', sortable: true },
                { key: "profissionalNome", label: "Profissional executante", class: 'col-max', sortable: true },
                { key: "actions", label: "Ações", class: 'col-min', sortable: true },
            ]

            return fields
        },
        agendados() {

            return this.model.agendados ?? []
        },
        realizados() {

            return this.model.realizados ?? []
        }
    },
    created() {

        this.repositories = {
            exame: this.getConectaSusRepository('exameImagem.exameAgendadoRealizado'),
            impressao: this.getConectaSusRepository('impressao.exameImagem'),
        },

        this.load();
    },
    filters: {
        ...format,
    },
    data() {
        return {
            form: {},
            model: {
                exame: null,
                exameId: null,
                exameNome: '',
                pacienteId: null,
                motivoId: null,
                periodo: {
                    start: null,
                    end: null,
                },
            },
            exames: false,
            observacao: null,
            saveAgendamento: {
                agendamentos: [],
            },
            agendamentoExame: [],
            items: [],
            enums: {
                preferenciaNome,
            },
            paciente: {
                id: null,
                nome: null,
                preferenciaNomeId: null,
                nomeSocial: '',
                prontuario: null,
                cpf: null,
                cns: null,
                telefone: null,
                dataNascimento: null,
                classificacaoId: null,
                idade: null,
                anos: null,
                meses: null,
                dias: null,
                sexo: null,
                sexoId: null,
                sexoDescricao: '',
                nomeMae: '',
                convenioMedicoNome: '',
                classificacaoNome: '',
            },
            endereco: {
                tipo: null,
                logradouro: null,
                numero: null,
                complemento: null,
                bairro: null,
                cep: null,
                municipio: null,
                uf: null,
            },
        }
    },
    mixins: [repository, error, object, formats, data, stringCase],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            if (this.id == null) {

                this.$emit('handleExit')
            } else {

                this.setLoading()

                this.repositories.exame.show(this.id)
                    .then(({ data }) => {

                        this.form = data.form
                        this.model = data.model

                        this.loadPaciente(data.form.paciente)
                        this.loadEndereco(data.form.endereco)

                        this.$nextTick().then(() => {

                            this.tabRefs = [
                                this.$refs.TabExamesAgendados,
                                this.$refs.TabAgendarExames,
                            ]
                        })
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        loadPaciente(paciente) {

            this.paciente.nome = paciente.nome
            this.paciente.preferenciaNome = paciente.preferenciaNome
            this.paciente.nomeSocial = paciente.nomeSocial
            this.paciente.telefone = paciente.telefone
            this.paciente.dataNascimento = paciente.dataNascimento
            this.paciente.situacaoFamiliar = paciente.situacaoFamiliar
            this.paciente.rg = paciente.rg
            this.paciente.cpf = paciente.cpf
            this.paciente.classificacaoId = paciente.classificacaoId
            this.paciente.classificacaoNome = paciente.classificacaoNome
            this.paciente.convenioMedicoNome = paciente.convenioMedicoNome
            this.paciente.cns = paciente.cns
            this.paciente.prontuario = paciente.prontuario
            this.paciente.unidadeReferencia = paciente.unidade
            this.paciente.sexo = paciente.sexo.descricao
        },
        loadEndereco(endereco) {

            this.endereco.tipo = endereco.logradouro.tipo
            this.endereco.logradouro = endereco.logradouro
            this.endereco.numero = endereco.numero
            this.endereco.complemento = endereco.complemento
            this.endereco.bairro = endereco.logradouro.bairro.nome
            this.endereco.cep = endereco.cep
            this.endereco.municipio = endereco.municipio.nome
            this.endereco.uf = endereco.municipio.estado.uf
            this.endereco.ibge = endereco.municipio.ibge
        },
        imprimirHistorico() {

            this.setLoading()

            this.repositories.impressao.historicoExame(this.id)
                .then(response => {

                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    props: {
        id: { type: Number }
    },
}
</script>

<style scoped>
p {
    margin: 0!important;
}
</style>